module.exports = __webpack_public_path__ + "static/media/wgl3.png.f5576575.jpg";